module.exports = __webpack_public_path__ + "static/media/contentlinkarrow.cc9fec5e.svg";